import { StatusCode } from "api/protocols";
import { GetFacilityGuest } from "api/rpc/2024-04/guest/facility";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";

interface IParams {
  facilityShortName: string;
}
/**
 * @description Redirect all booking engine routes to the Client Portal using the
 *              client_short_name returned on the facility
 * @param props
 * @returns
 */
export default function ClientPortalRedirection() {
  const { t } = useTranslation();
  const { facilityShortName } = useParams<IParams>();
  const history = useHistory();

  useEffect(() => {
    void handleRedirect();
  }, []);

  async function handleRedirect() {
    if (facilityShortName) {
      const facilityRes = await GetFacilityGuest({ short_name: facilityShortName }, true);
      if (facilityRes.status === StatusCode.OK) {
        const facility = facilityRes?.data[0];
        if (facility?.client_short_name && facility?.short_name) {
          history.push(`/portal/${facility?.client_short_name}/teetimes/${facility?.short_name}`);
          return;
        }
      }
    }
    history.push("/login");
  }

  return <div>{t('Redirecting...')}</div>;
}
